import { Slider as MantineSlider } from '@mantine/core';
import type { SliderProps as MantineSliderProps } from '@mantine/core';

import type { LockedProps } from '../types';

type SliderProps = Omit<MantineSliderProps, LockedProps>;

export const Slider = (props: SliderProps) => {
  return <MantineSlider {...props} />;
};
